<template lang="html">

  <section class="reports">
    <div class="pageHeading">
      <h1>Reporting</h1>
    </div>

    <p>Advanced Reporting Will Go Here</p>

  </section>

</template>

<script lang="js">
    import participantsStatusList from '../components/ParticipantsStatusList'
  export default  {
    name: 'reports',
    props: [],
    components: {
        participantsStatusList
    },
    mounted() {
    },
    data() {
      return {

      }
    },
      computed: {

      },

      methods: {

      }
}
</script>

<style scoped lang="scss">
  .reports {

  }
</style>
